export default class Scroll
{
    constructor() {
        if (Scroll.INSTANCE) {
            return Scroll.INSTANCE
        } else {
            Scroll.INSTANCE = this
        }

        this.lastTime = window.performance.now()
        this._y = 0
        this._onScrollCb = []
        this._onScroll = this._onScroll.bind(this)
        this._update = this._update.bind(this)
        this._raf = requestAnimationFrame(this._update)

        document.addEventListener('scroll', this._onScroll, false)
    }

    get y() {
        return this._y
    }

    addOnScroll(callback) {
        this.removeOnScroll(callback)
        this._onScrollCb.push(callback)
        return true
    }

    removeOnScroll(callback) {
        const i = this._onScrollCb.indexOf(callback)
        if (i > -1) {
            this._onScrollCb.splice(i, 1)
            return true
        }
        return false
    }

    update(time = window.performance.now()) {
        this.lastTime = time
        let y = this._y

        if (this._hasScrolled) {
            y = window.pageYOffset || document.documentElement.scrollTop
            this._y = y
            this._hasScrolled = false
            Scroll._dispatch(this._onScrollCb, this._y)
        }
    }

    _update(time) {
        this.update(time)
        this._raf = requestAnimationFrame(this._update)
    }

    _onScroll() {
        this._hasScrolled = true
    }

    static _dispatch(list, ...datas) {
        for (const cb of list) {
            cb(...datas)
        }
    }
}